import React, { useEffect, useState } from "react";
import style from "css/solution.module.scss";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import CustomPlatform from "./customPlatform";

function Medilink(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 889px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 890px) and (max-width: 1599px)",
  });
  const [tab, setTab] = useState("medilink");
  const location = useLocation();
  const navigate = useNavigate();

  const normalizeTab = (value) => {
    const v = (value ?? "").toString().trim().toLowerCase();
    if (v === "customplatform") return "customplatform";
    if (v === "medilink") return "medilink";
    return null;
  };

  // URL(?tab=)이 있으면 그 값을 우선으로 탭을 트리거
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const next = normalizeTab(params.get("tab")) || "medilink";
    setTab(next);
  }, [location.search]);

  const setAndSyncTab = (nextTab) => {
    const next = normalizeTab(nextTab) || "medilink";
    setTab(next);

    const params = new URLSearchParams(location.search);
    if (next === "medilink") params.delete("tab");
    else params.set("tab", next);

    const search = params.toString();
    navigate(
      { pathname: location.pathname, search: search ? `?${search}` : "" },
      { replace: true },
    );
  };

  return (
    <>
      <SEOMeta
        title="MediLink, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - MediLink"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, MediLink, 텔레헬스 시스템, 비대면 진료
        원격 진료, 화상 회진"
      />
      <div className={style.medilink_tab_wrapper} style={{ paddingTop: props.type === "popup" && 0, marginTop: props.type === "popup" && 0, padding: props.type === "popup" && 0, marginBottom: props.type === "popup" && 10 }}>
        <div className={style.medilink_tab_container}>
          <div
            className={`${tab === "medilink" ? style.on : ""} ${style.cursor}`}
            onClick={() => setAndSyncTab("medilink")}
          >
            <bold>원격진료·회진</bold>{"\u00A0"}MediLink
          </div>
          <div
            className={`${tab === "customplatform" ? style.on : ""} ${style.cursor}`}
            onClick={() => setAndSyncTab("customplatform")}
          >
            <bold>원격협진</bold>{"\u00A0"}MediLink
          </div>
        </div>
      </div>
      {
        tab === "customplatform"
          ?
          <CustomPlatform />
          :
          <>
            <div className={style.content} >
              <div className={`${style.title_area} ${style.medilink}`}>
                <div className={`${style.title_wrap} ${style.medilink}`}>
                  <div className={`${style.title} ${style.medilink}`}>
                    {!isMobile && !isTablet ? (
                      <span className={style.medilink_title}>
                        <bold>원격진료</bold> 및 <bold>화상회진</bold>을 위한
                        <br />
                        통합 텔레헬스 시스템,
                      </span>
                    ) : (
                      <span className={style.medilink_title}>
                        <bold>
                          원격진료 및 화상회진을 위한
                          <br />
                          통합 텔레헬스 시스템
                        </bold>
                      </span>
                    )}
                    <img
                      className={style.medilink_logo}
                      alt="medilink"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilink_logo${!isMobile && !isTablet ? "" : "_m"}.png`}
                    />
                  </div>
                  <div className={style.medilink_desc}>
                    병원 진료 프로세스를 그대로 반영한
                    <br />
                    ZOOM 기반 원격진료 · 화상회진 시스템입니다.
                    <br />
                    환자 대기부터 진료 접속, 진료 기록 연동까지
                    <br />
                    비대면 진료 전 과정을 하나의 흐름으로 연결합니다.
                  </div>
                </div>
                <img
                  alt="medilink"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilink_title${!isMobile && !isTablet ? "" : "_m"}.png`}
                />
              </div>
            </div>

            <div className={style.overview_wrap}>
              <div className={style.structure_wrap}>
                <div className={style.structure_title}>
                  병원 시스템과 Zoom을 연결하는
                  <br />
                  MediLink 구조
                </div>
                <div className={style.structure_subtitle}>
                  MediLink는 병원의 종합의료정보시스템(HIS)과 Zoom을 연동합니다.
                </div>
                <div className={style.structure_feature_list}>
                  <div className={style.structure_feature}>
                    <div
                      className={`${style.structure_feature_header} ${style.green}`}
                    >
                      <div className={style.circle}>
                        <img
                          alt="medilink_structure_1"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStructure1${!isMobile && !isTablet ? "" : "_m"}.png`}
                          style={{ height: 41, width: 48 }}
                        />
                      </div>
                      <div>환자 대기화면</div>
                    </div>
                    <div className={style.structure_feature_content}>
                      <div className={style.content_list}>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>예약된 미팅번호를 통한 사용자 접근</span>
                        </div>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>플랫폼 돈앤매너 & 대기화면 병원 맞춤형 서비스</span>
                        </div>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>대기 현황 및 간호사 안내사항 확인</span>
                        </div>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>대기 시 불편사항 사전 입력</span>
                        </div>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>의사가 진료 시작 시 환자 입장 가능하도록 개발</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={style.structure_feature}>
                    <div
                      className={`${style.structure_feature_header} ${style.blue}`}
                    >
                      <div className={style.circle}>
                        <img
                          alt="medilink_structure_2"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStructure2${!isMobile && !isTablet ? "" : "_m"}.png`}
                          style={{ height: 44, width: 44 }}
                        />
                      </div>
                      <div>환자 대기화면</div>
                    </div>
                    <div className={style.structure_feature_content}>
                      <div className={style.content_list}>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.blue}`}
                          ></div>
                          <span>ZOOM 이력 데이터 Webhook 방식으로 수집</span>
                        </div>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.blue}`}
                          ></div>
                          <span>수집된 데이터 종합의료정보시스템 전달</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={style.structure_feature}>
                    <div
                      className={`${style.structure_feature_header} ${style.green}`}
                    >
                      <div className={style.circle}>
                        <img
                          alt="medilink_structure_3"
                          src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStructure3${!isMobile && !isTablet ? "" : "_m"}.png`}
                          style={{ height: 35, width: 56 }}
                        />
                      </div>
                      <div>환자 대기화면</div>
                    </div>
                    <div className={style.structure_feature_content}>
                      <div className={style.content_list}>
                        <div className={style.content}>
                          <div
                            className={`${style.content_circle} ${style.green}`}
                          ></div>
                          <span>Meeting SDK 통해 의료진 미팅화면 제공</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isMobile ?
                  <div className={style.structure_footer}>
                    비대면 진료 환경에서도<br /><bold>기존의 의료 정보 시스템의 흐름을</bold><br />
                    <bold>유지</bold>할 수 있도록<br />설계되었습니다.
                  </div>
                  :
                  <div className={style.structure_footer}>
                    비대면 진료 환경에서도<br /><bold>기존의 의료 정보 시스템의 흐름을 유지</bold>할 수 있도록 설계되었습니다.
                  </div>
                }
              </div>
              <div className={style.process_wrap}>
                {!isMobile && !isTablet ? (
                  <div className={style.process_title}>
                    실제 병원업무 흐름을 그대로 반영한
                    <br />
                    진료 프로세스
                  </div>
                ) : (
                  <div className={style.process_title}>
                    실제 병원업무 흐름을
                    <br /> 그대로 반영한 진료 프로세스
                  </div>
                )}
                <div className={style.process_map}>
                  <div className={style.step}>
                    <div className={style.step_header}>
                      <img
                        className={style.step_icon_1}
                        alt="medilinkStep1"
                        src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStep1${!isMobile && !isTablet ? "" : "_m"}.png`}
                      // style={{ height: 41, width: 41 }}
                      />
                      <span>환자 진료 예약</span>
                    </div>
                    {!isMobile && isTablet ?
                      <div className={style.step_content}>
                        병원 종합의료정보시스템(HIS) 또는<br />
                        진료 예약 시스템과 연동되어<br />
                        환자는 사전 예약을 통해 비대면 진료 또는<br />
                        화상회진 일정을 접수합니다.
                      </div>
                      :
                      <div className={style.step_content}>
                        병원 종합의료정보시스템(HIS) 또는
                        진료 예약 시스템과 연동되어
                        환자는 사전 예약을 통해 비대면 진료 또는
                        화상회진 일정을 접수합니다.
                      </div>
                    }
                  </div>
                  <div className={style.arrow}>
                    <img
                      alt="arrow"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/${!isMobile && !isTablet ? "arrowForward" : "arrowDownward"}.png`}
                    />
                  </div>
                  <div className={style.step}>
                    <div className={style.step_header}>
                      <img
                        className={style.step_icon_2}
                        alt="medilinkStep2"
                        src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStep2${!isMobile && !isTablet ? "" : "_m"}.png`}
                      // style={{ height: 51, width: 51 }}
                      />
                      <span>진료 대기 확인</span>
                    </div>
                    <div className={style.step_content}>
                      환자는 예약된 일정에 맞춰 MediLink 대기 화면에 접속하며, 본인의
                      순서, 대기 인원 등을 실시간으로 확인할 수 있습니다. 또한, 현재
                      증상이나 전달사항을 사전에 작성 할 수 있습니다.
                    </div>
                  </div>
                  <div className={style.arrow}>
                    <img
                      alt="arrow"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/${!isMobile && !isTablet ? "arrowForward" : "arrowDownward"}.png`}
                    />
                  </div>
                  <div className={style.step}>
                    <div className={style.step_header}>
                      <img
                        className={style.step_icon_3}
                        alt="medilinkStep3"
                        src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStep3${!isMobile && !isTablet ? "" : "_m"}.png`}
                      // style={{ height: 46, width: 33 }}
                      />
                      <span>의료진 진료 시작</span>
                    </div>
                    <div className={style.step_content}>
                      의료진은 MediLink의 의료진 전용 화면을 통해 진료 대기 중인 환자
                      목록을 확인하고, 개별 환자에 대해 '진료 시작'을 선택합니다.
                    </div>
                  </div>
                  <div className={style.arrow}>
                    <img
                      alt="arrow"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/${!isMobile && !isTablet ? "arrowForward" : "arrowDownward"}.png`}
                    />
                  </div>
                  <div className={style.step}>
                    <div className={style.step_header}>
                      <img
                        className={style.step_icon_4}
                        alt="medilinkStep4"
                        src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkStep4${!isMobile && !isTablet ? "" : "_m"}.png`}
                      // style={{ height: 36, width: 41 }}
                      />
                      <span>진료 이력 및 데이터 자동 수집</span>
                    </div>
                    <div className={style.step_content}>
                      진료 종료 후에 비대면 진료 관련 메타 데이터는 자동 수집되며,
                      병원의 진료 이력 관리 시스템에 연동됩니다.
                    </div>
                  </div>
                </div>
                {!isMobile && !isTablet ? (
                  <div className={style.process_footer}>
                    진료 “전-중-후” <bold>모든 단계</bold>가<br />
                    <bold>하나의 시스템 안에서</bold> 자연스럽게 이어집니다.
                  </div>
                ) : (
                  <div className={style.process_footer}>
                    진료 “전-중-후”
                    <br />
                    <bold>모든 단계가 하나의 시스템 안에서</bold>
                    <br />
                    자연스럽게 이어집니다.
                  </div>
                )}
              </div>
            </div>

            <div className={style.screen_wrap}>
              {!isMobile && !isTablet ? (
                <div className={style.screen_title}>
                  사용자 별로 분리된 <bold>직관적인 화면 구성</bold>
                </div>
              ) : (
                <div className={style.screen_title}>
                  사용자 별로 분리된
                  <br />
                  <bold>직관적인 화면 구성</bold>
                </div>
              )}
              <div className={style.screen_content}>
                <div className={`${style.row} ${style.rowTop}`}>
                  <div className={`${style.card} ${style.green}`}>
                    <img
                      alt="medilinkScreen1"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkScreen1${!isMobile && !isTablet ? "" : "_m"}.png`}
                    />
                    <div className={style.card_content}>
                      <div className={style.title}>1. 환자</div>
                      <div>
                        <div>진료 대기 화면 제공</div>
                        <div>대기 현황 확인</div>
                        <div>진료 전 불편사항 사전 입력</div>
                        <div>의료진 진료 시작 시 자동입장</div>
                      </div>
                    </div>
                  </div>
                  <div className={`${style.card} ${style.blue}`}>
                    <img
                      alt="medilinkScreen2"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkScreen2${!isMobile && !isTablet ? "" : "_m"}.png`}
                    />
                    <div className={style.card_content}>
                      <div className={style.title}>2. 의료진</div>
                      <div>
                        <div>비대면 진료 전용 화면</div>
                        <div>화상회진 대기 화면</div>
                        <div>PC, Mobile, Tablet 환경 지원</div>
                        <div>통계, 수치 등 병원 맞춤형 데이터 제공</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${style.row} ${style.rowBottom}`}>
                  <div className={`${style.card} ${style.blue}`}>
                    <img
                      alt="medilinkScreen3"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkScreen3${!isMobile && !isTablet ? "" : "_m"}.png`}
                    />
                    <div className={style.card_content}>
                      <div className={style.title}>3. 보호자 면회</div>
                      <div>
                        <div>화상회진 대기 화면</div>
                        <div>PC, Mobile 지원</div>
                      </div>
                    </div>
                  </div>
                  <div className={`${style.card} ${style.green}`}>
                    <img
                      alt="mmedilinkScreen4"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkScreen4${!isMobile && !isTablet ? "" : "_m"}.png`}
                    />
                    <div className={style.card_content}>
                      <div className={style.title}>4. 관리자</div>
                      <div>
                        <div>계정 관리</div>
                        <div>컨텐츠 관리</div>
                        <div>비대면 진료 이력 관리</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={style.highlight_wrap}
              style={{
                backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkHighlightBg${isMobile ? "_m" : ""}.png')`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div
                className={style.highlight_inner_wrap}
                style={{
                  backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/solution/medilink/medilinkHighlightInnerBg${isMobile ? "_m" : ""}.png')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {
                  isMobile ?
                    <div>비대면 진료,<br /><bold>병원 진료의 연장선</bold><br />이어야 합니다.</div>
                    : isTablet ?
                      <div>비대면 진료,<br /><bold>병원 진료의 연장선</bold>이어야 합니다.</div>
                      :
                      <div>비대면 진료, <bold>병원 진료의 연장선</bold>이어야 합니다.</div>
                }
                {
                  isMobile ?
                    <div>
                      MediLink는 의료진과 환자 모두의 흐름을<br />정리하는 시스템 입니다.<br />
                      병원의 잔료 방식은 유지하고,<br /><bold>비대면 환경만 자연스럽게 확장</bold>하세요.
                    </div>
                    : isTablet ?
                      <div>
                        MediLink는 의료진과 환자 모두의 흐름을 정리하는 시스템 입니다.<br />
                        병원의 잔료 방식은 유지하고, <bold>비대면 환경만 자연스럽게 확장</bold>하세요.
                      </div>
                      :
                      <div>
                        MediLink는 의료진과 환자 모두의 흐름을 정리하는 시스템 입니다.<br />
                        병원의 잔료 방식은 유지하고, <bold>비대면 환경만 자연스럽게 확장</bold>하세요.
                      </div>
                }
              </div>
            </div>

            {props.type === "popup" ? (
              <div style={{ marginBottom: "70px" }}>
                <Consult />
              </div>
            ) : (
              <div className={style.device_consult_wrapper}>
                <Questions />
              </div>
            )}
          </>
      }
    </>
  );
}

export default Medilink;
